import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import arrow from "../../../../../assets/chevron-down.svg";
import trash from "../../../../../assets/ic-trash.svg";
import styles from './dropoff.module.css';

import Collapse from "@material-ui/core/Collapse";
import { withTranslation, Trans } from "react-i18next";
import Backdrop from "@material-ui/core/Backdrop";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { withStyles } from "@material-ui/core/styles";
import {
  Add_dropoff,
  Edit_Travel_set_Dropoff_inputs,
  Set_Pickup_address,
  Set_SearchAutoCompleteLoading,
  Set_latlng,
  Edit_Travel_set_Dropoff,
  Edit_Travel_Operate_Changed,
  OpenNewFav,
  SetopenAddressBookInNewOrder,
} from "../../../../../Redux/actions/actionNames";
import {
  SearchAutoCompleteAction,
  SearchAddressAction,
  PlaceIdDetailsAction,
  getFavAddressInfoAction,
  SearchAutoCompleteAction_local_address,
} from "../../../../../Redux/actions/actions";
import closeCircle from "../../../../../assets/close-cricle.svg";
import savedarrow from "../../../../../assets/icon-arrow-triangle-up.svg";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import CircularProgress from "@material-ui/core/CircularProgress";
import Schedule from "./Schedule";
import momentJalaali from "moment-jalaali";
import { get_lang } from "../../../../../helper/UserData/userdate";
import _, { debounce, isEmpty, throttle } from "lodash";
import PhoneInput from "react-phone-number-input";
import { getCenterMap, getCountryWithDomain, setCenterMap } from "../../../../../helper/module";
import { useLocalServices } from "../../../../../hooks";
import drag_drop from "../../../../../assets/drag_drop.svg";
import { v4 as uuidv4 } from 'uuid';
import address_database from "../../../../../assets/address_database.webp";
import MapSearch from "../../../../../assets/MapSearch.webp";
import iconicperson from "../../../../../assets/icon-ic-person.svg";
import icClock from "../../../../../assets/ic-clock.svg";
import iconIcPin from "../../../../../assets/icon-ic-pin.svg";
import icclockcolorfull from "../../../../../assets/ic-clock-colorfull.svg";
import Typography from "../../../../../design-system/lib/Typography";
import Button from "../../../../../design-system/lib/Button";
import SearchList from "../../../../../design-system/lib/SearchList";
import IconProvider from "../../../../../design-system/lib/IconProvider";
import { ADDRESS_BOOK, CLOSE_DARK, DRAG, DROPOFF, HISTORY, INFO_CIRCLE, LOCATION, PICKUP } from "../../../../../assets";
import DropDown from "../../../../../design-system/lib/DropDown";
import RecentAddressItem from "../../../../../components/new-order/pickup/components/recentAddressItem";
import AddressItem from "../../../../../components/shared/AddressItem";
import DropoffInfoEditOrder from "./dropOff/info";
import { emailValidate } from "./pickup";
import { ServicesApi } from "../../../../../service/API/service";
import ServicePoint_addressItem from "../../../../../components/new-order/pickup/components/servicePoint_addressItem";
import service_point from '../../../../../assets/service_point.svg';
import service_point_color from '../../../../../assets/service_point_color.svg';
import location_gray from '../../../../../assets/location_gray.svg';
import ServicePoint_addressItemEditAddress from "../../../../../components/new-order/pickup/components/servicePoint_addressItem edit";
import clsx from "clsx";

const BackdropCustom = withStyles({
  backdrop: {
    zIndex: 5000,
    backgroundColor: "rgba(0, 0, 0, 0)",
    color: "#00000",
  },
})((props) => (
  <Backdrop
    {...props}
    style={{
      zIndex: 5000,
      backgroundColor: "rgba(0, 0, 0, 0)",
      color: "#00000",
    }}
  />
));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      loading: false,
      ordered: true,
      showpoper: false,
      showpoperSaved: false,
      getFavAddressLoading: false,
      searchAddrees: "",
      list: [],
      cursor:null,
      sessionToken: null ,
      isLocalAddressActive:
      global.config.dispatcherSettings.isLocalAddressActive,
    localSearchIsActive: global.config.dispatcherSettings.isLocalAddressActive
      ? true
      : false,
      servicepoints: [],
      servicepointsIsLoading: false, 
    };
    this.anchorEl = React.createRef();


    this.throttleHandleChange = debounce(
      this.throttleHandleChange.bind(this),
      800
    );


    this.throttleHandleChangeSP = debounce(
      this.throttleHandleChangeSP.bind(this),
      800
    );
  }


  throttleHandleChangeSP(value) {
    (async () => {

      this.setState({
        servicepointsIsLoading: true
      })
      const Services = new ServicesApi();
      const ServicePoints = await Services.ServicePoints({
        deliveryMethodId: this.props.deliveryMethod,
        locationType: "dropoff",
        search: value
      })


      this.setState({
        servicepoints: ServicePoints,
        servicepointsIsLoading: false
      })

    })();

  }

  componentDidMount() {

    (async () => {

      this.setState({
        servicepointsIsLoading: true
      })
      const Services = new ServicesApi();
      const ServicePoints = await Services.ServicePoints({
        deliveryMethodId: this.props.deliveryMethod,
        locationType: "dropoff"
      })


      this.setState({
        servicepoints: ServicePoints,
        servicepointsIsLoading: false
      })

    })();
  }

  componentDidUpdate() {
    this._setCursorPositions();
  }

  _setCursorPositions = () => {
    //reset the cursor position for input
    if(this.anchorEl.current && this.state.cursor){
       this.anchorEl.current.selectionStart = this.state.cursor;
       this.anchorEl.current.selectionEnd = this.state.cursor;
    }

  };



  handleChangeLocalSearch = () => {
    this.setState(
      {
        localSearchIsActive: !this.state.localSearchIsActive,
      },
      () => {
        this.notThrottleHandleChange(String(this.props.address));
      }
    );
  };

  notThrottleHandleChange(value) {
    let center = getCenterMap(this.props.mapRef, this.props.center);

    if (!this.state.localSearchIsActive) {
      this.props.dispatch(
        SearchAutoCompleteAction(this.props.dispatch, {
          query: value,
          latitude: center.lat,
          longitude: center.lng,
          sessionToken: this.state.sessionToken,
        })
      );
    } else {
      this.props.dispatch(
        SearchAutoCompleteAction_local_address(this.props.dispatch, {
          query: value,
        })
      );
    }
  }

  throttleHandleChange(value) {
    let center = getCenterMap(this.props.mapRef, this.props.center);

    if (!this.state.localSearchIsActive) {
      this.props.dispatch(
        SearchAutoCompleteAction(this.props.dispatch, {
          query: value,
          latitude: center.lat,
          longitude: center.lng,
          sessionToken: this.state.sessionToken,
        })
      );
    } else {
      this.props.dispatch(
        SearchAutoCompleteAction_local_address(this.props.dispatch, {
          query: value,
        })
      );
    }
  }

  handleshowpoper = () => {
    this.setState({
      showpoper: !this.state.showpoper,
      searchAddrees: "",
      showpoperSaved: false,
    });
  };

  handleshowpoperDrop = () => {
    if (this.props.customerId) {
      this.setState({
        showpoperSaved: !this.state.showpoperSaved,
        searchAddrees: "",
        showpoper: false,
      });
    }
  };
  handleSavedDropInput = (e) => {
    this.setState({
      searchAddrees: e.target.value,
    });
  };

  idgenerator = () => {
    var number = Math.random(); // 0.9394456857981651
    number.toString(36); // '0.xtis06h6'
    var id = number.toString(36).substr(2, 9); // 'xtis06h6'
    return id.toString();
  };

  handleCollapse = () => {
    this.props.handleCollapse({
      type: "dropoff",
      id: this.state.id,
      firstDropOff: this.props.first
    });
  };


  handlePhoneInput = (value, id) => {
    this.props.dispatch(Edit_Travel_Operate_Changed());
    this.props.dispatch(
      Edit_Travel_set_Dropoff_inputs({
        name: id,
        value: value,
        firstDropOff: this.props.first,
        id: this.state.id,
      })
    );
  };



  handleDropOffInputs = (e, name, value, id) => {
    try {
      
    this.props.dispatch(Edit_Travel_Operate_Changed());

    if (((id ? id : e.target.id) === "address") || name === "address") {

      this.setState({
        sessionToken: this.state.sessionToken ? this.state.sessionToken : uuidv4(),
        cursor : e.target.selectionStart

      })

      if (value ? value : e.target.value) {
        this.props.dispatch(Set_SearchAutoCompleteLoading(true));

      }
      if (value || e.target.value != "") {

        (value ? value : e.target.value)  && this.throttleHandleChange(value ? value : e.target.value, this.state.sessionToken)
      }

    }
    this.props.dispatch(
      Edit_Travel_set_Dropoff_inputs({
        name: id || name || e.target.id,
        value: value ? value : e.target.value,
        firstDropOff: this.props.first,
        id: this.state.id,
      })
    );

    } catch (error) {
      
    }

  };

  handleList = (item) => {
    if (item.coordinates) {
      this.props.dispatch(Edit_Travel_Operate_Changed());

      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "address",
          value: item.secondaryAddress ? item.address + " , " + item.secondaryAddress : item.address,
          firstDropOff: this.props.first,
          id: this.state.id,
        })
      );
      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "adresss_loc",
          value: {
            lng: item.coordinates[0],
            lat: item.coordinates[1],
          },
          firstDropOff: this.props.first,
          id: this.state.id,
        })
      );

      this.props.dispatch(
        Set_latlng({
          lng: item.coordinates[0],
          lat: item.coordinates[1],
        })
      );

      this.setState({
        sessionToken: null
      })

    } else {

      this.setState({
        sessionToken: this.state.sessionToken ? this.state.sessionToken : uuidv4()
      }, () => {
        this.props.dispatch(
          PlaceIdDetailsAction(this.props.dispatch, { placeId: item.placeId, sessionToken: this.state.sessionToken }, (res) => {
            this.props.dispatch(Edit_Travel_Operate_Changed());
            this.setState({
              sessionToken: null
            })

            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "address",
                value: res.address,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );

            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "adresss_loc",
                value: {
                  lng: res.coordinates[0],
                  lat: res.coordinates[1],
                },
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );

            this.props.dispatch(
              Set_latlng({
                lng: res.coordinates[0],
                lat: res.coordinates[1],
              })
            );
          })
        );
      })


    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.firstDropOff ? "dropoff" : nextProps.id,
    });
  }

  resetPickup = () => {
    this.props.dispatch(Edit_Travel_Operate_Changed());

    this.props.dispatch(
      Edit_Travel_set_Dropoff_inputs({
        name: "address",
        value: "",
        firstDropOff: this.props.first,
        id: this.state.id,
      })
    );
    this.props.dispatch(
      Edit_Travel_set_Dropoff_inputs({
        name: "adresss_loc",
        value: { lng: "", lat: "" },
        firstDropOff: this.props.first,
        id: this.state.id,
      })
    );
    this.props.dispatch(
      Edit_Travel_set_Dropoff_inputs({
        name: "placeId",
        value: "",
        firstDropOff: this.props.first,
        id: this.state.id,
      })
    );
  };

  validate(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  
  removeDropOff = () => {
    this.props.dispatch(Edit_Travel_Operate_Changed());

    this.props.removeDrop(this.state.id);
  };

  hanldeOpenNewFav = () => {
    this.props.dispatch(OpenNewFav(true));
  };

  mapSetView = (e) => {
    setCenterMap(this.props.mapRef, e)
  };

  handleListFavAddress = (e) => {
    this.resetPickup();

    this.props.dispatch(Edit_Travel_Operate_Changed());

    this.setState({
      showpoperSaved: false,
      getFavAddressLoading: true,
    });
    // address: "Somewhere"
    // customerId: "ckfezc72o01f1xxo81la4bvl9"
    // id: "ckh3mcgda0d847bo87td8fk1v"
    // title: "HomeTown"
    if (this.props.customerId) {
      this.props.dispatch(
        getFavAddressInfoAction(
          this.props.dispatch,
          { customerId: e.customerId, id: e.id },
          (res) => {
            this.setState({
              getFavAddressLoading: false,
            });
            this.mapSetView({ lng: res.coordinates[0], lat: res.coordinates[1] });

            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "address",
                value: res.address,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );
            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "adresss_loc",
                value: { lng: res.coordinates[0], lat: res.coordinates[1] },
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );
            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "block",
                value: res.buildingBlock,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );
            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "floor",
                value: res.floor,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );

            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "unit",
                value: res.room,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );
            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "senderFullName",
                value: res.fullName,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );
            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "senderPhoneNumber",
                value: res.phone,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );
            this.props.dispatch(
              Edit_Travel_set_Dropoff_inputs({
                name: "noteForDriver",
                value: res.customerDescription,
                firstDropOff: this.props.first,
                id: this.state.id,
              })
            );
          }
        )
      );
    }

  };


  handleRecentList = (item) => {

    // this.props.dispatch(
    //   Set_latlng({ lng: item.coordinates[0], lat: item.coordinates[1] })
    // );

    // dispatch(
    //   Set_Pickup_address({
    //     ...item,
    //     address: item.address,
    //     adresss_loc: { lng: item.coordinates[0], lat: item.coordinates[1] },
    //     block: item.buildingBlock,
    //     floor: item.floor,
    //     unit: item.room
    //   })
    // );
    // mapSetView({
    //   lng: item.coordinates[0],
    //   lat: item.coordinates[1],
    // });

    // handleShowInfo()


    this.props.dispatch(Edit_Travel_Operate_Changed());

    this.setState({
     sessionToken: null,
   });

   this.props.dispatch(
    Edit_Travel_set_Dropoff_inputs({
      name: "address",
      value: item.address,
      firstDropOff: this.props.first,
      id: this.state.id,
    })
  );

  
  this.props.dispatch(
    Edit_Travel_set_Dropoff_inputs({
      name: "adresss_loc",
      value: { lng: item.coordinates[0], lat: item.coordinates[1] },
      firstDropOff: this.props.first,
      id: this.state.id,
    })
  );

 
    this.props.dispatch(
      Set_latlng({
        lng: item.coordinates[0],
        lat: item.coordinates[1],
      })
    );

  }

  GetserachListItemOnclick = () => {
    if (_.isEmpty(this.props.address)) {
      return this.handleRecentList
    } else {
      return this.handleList
    }
  };

  GetSearchListError = () => {

    if (this.props.locationType != "address") {


      if (_.isEmpty(this.props.address)) {
        if (!this.state.servicepoints || _.isEmpty(this.state.servicepoints)) {
          return {
            errorDescription: this.props.t("Add service points in admin center"),
            errorTitle: this.props.t("No service point available"),
            errorIcon: service_point,
            errorActionTitle: this.props.t("Add service point")
          }
        } else {
          return null
        }
      } else if (!_.isEmpty(this.props.address)) {
        if ((!this.state.servicepointsIsLoading && (this.state.servicepoints.length === 0 || _.isEmpty(this.state.servicepoints)))) {
          return {
            errorDescription: this.props.t("NoResultfromLocalDatabaseD"),
            errorIcon: null,
          }
        }
      }


    } else {    //no recent address
    if (this.props.recentAddress?.length == 0 && _.isEmpty(this.props.address)) {
      return {
        errorDescription: this.props.t("NoRecentAddressD"),
        errorTitle: this.props.t("NoRecentAddress"),
        errorIcon: HISTORY,
      }
    }

     //CustomerIsNotChoosed


     if ((!this.props.suggestListPickUpDropOffLoading &&
       this.props.suggestPickUpDropOffListData.length === 0 && !_.isEmpty(this.props.address)) || (!_.isEmpty(this.props.address) && !this.props.suggestListPickUpDropOffLoading && !this.props.suggestPickUpDropOffListData)) {
       return {
         errorDescription: this.props.t("NoResultfromLocalDatabaseD"),
         errorTitle: this.props.t(this.state.localSearchIsActive ? "NoResultfromLocalDatabase" : "NoResultfromMapService"),
         errorIcon: null,
       }
     }
 }
   };



   GetserachListItem = () => {

    if (_.isEmpty(this.props.address)) {
      return RecentAddressItem
    } else {
      return AddressItem
    }


     }


     serachListData = () => {

       if (this.props.locationType != "address") {
         if (this.state.servicepoints && !_.isEmpty(this.state.servicepoints)) {
           return this.state.servicepoints
         } else {
           return null
         }
       }


      if (_.isEmpty(this.props.address)) {

       if (_.isEmpty(this.props.recentAddress)) {
         return null //error recentAddress
       } else {
         return this.props.recentAddress
       }

     } else {
       if (_.isEmpty(this.props.suggestPickUpDropOffListData)) {
         return null //error suggestPickUpDropOffListData
       } else {
         return this.props.suggestPickUpDropOffListData
       }
     }


    }


    handleShowInfo = () => {

  
      const myEvent = new CustomEvent("closeSliders", { detail: null });
      document.dispatchEvent(myEvent);
  
  
      this.handleCollapse()
  
    }


    
  openAddressbook = () => {

    


    setTimeout(() => {
      if (this.props.openAddressBook && this.props.addressBookSource) {
        this.props.dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
        const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);
      } else {
        const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);
        this.props.dispatch(
          SetopenAddressBookInNewOrder(
            true,
            "dropoff",
            this.props.id,
            "AddressbookDropOf",
            this.props.first
          )
        );
      }
 }, 100);
  }


  pickupRequiredCheck = () => {
    if (this.props.deliveryMethodSetting) {
      let name = false, email = false, phone = false;

      if (this.props.deliveryMethodSetting.isDropoffAddressNameRequired) {
        if (this.props.fullName && String(this.props.fullName).trim().length > 0) {
          name = true
        } else {
          name = false
        }
      } else {
        name = true
      }

      if (this.props.deliveryMethodSetting.isDropoffAddressPhoneRequired) {
        if (this.props.phone && String(this.props.phone).trim().length > 0) {
          phone = true
        } else {
          phone = false
        }
      } else {
        phone = true
      }


      if (this.props.deliveryMethodSetting.isDropoffAddressEmailRequired) {
        if (this.props.email && String(this.props.email).length > 0 && emailValidate(String(this.props.email))) {
          email = true
        } else {
          email = false
        }
      } else {
        email = true
      }



      return (name && phone && email);

    } else {
      return false
    }

  }


  GetserachListItemOnclickSP = (item) => {



       this.props.dispatch(Edit_Travel_Operate_Changed());

       this.props.dispatch(
         Edit_Travel_set_Dropoff_inputs({
           name: "address",
           value: item.address,
           firstDropOff: this.props.first,
           id: this.state.id,
         })
       );
       this.props.dispatch(
         Edit_Travel_set_Dropoff_inputs({
           name: "adresss_loc",
           value: { lng: item.coordinates.lng, lat: item.coordinates.lat },
           firstDropOff: this.props.first,
           id: this.state.id,
         })
       );

       this.props.dispatch(
         Edit_Travel_set_Dropoff_inputs({
           name: "namex",
           value: item.name,
           firstDropOff: this.props.first,
           id: this.state.id,
         })
       );

       this.props.dispatch(
         Edit_Travel_set_Dropoff_inputs({
           name: "idx",
           value: item.id,
           firstDropOff: this.props.first,
           id: this.state.id,
         })
       );


       this.props.dispatch(
         Set_latlng({ lng: item.coordinates.lng, lat: item.coordinates.lat })
       );

     }


  handleSearchSPInput = (e, name, value, id) => {
    if (e?.target?.ignore) {
      return null
    }

        try {

          this.props.dispatch(Edit_Travel_Operate_Changed());

          if (((id ? id : e.target.id) === "address") || name === "address") {
            if (e && e?.target.value != "") {
              e?.target?.value.length > 2 && this.throttleHandleChangeSP(e?.target.value)
              if (e?.target?.value.length == 0 && this.props.address?.length > 0) {
                this.throttleHandleChangeSP(e?.target.value)
              }
            }

            if (e?.target?.value.length == 0) {
              this.throttleHandleChangeSP("")
            }
          }
          this.props.dispatch(
            Edit_Travel_set_Dropoff_inputs({
              name: id || name || e.target.id,
              value: value ? value : e.target.value,
              firstDropOff: this.props.first,
              id: this.state.id,
            })
          );

        } catch (error) {

        }


      };



  render() {
    const { t } = this.props;

    if (isEmpty(String(this.props.adresss_loc.lat))) {
      return <div className={clsx(styles.PickupOnlyNewOrderContainer,   ["Ondemand" , "PickupDelivery"].indexOf(
            this.props.orderTypeActive
          ) > -1 && styles.PickupDelivery)}>
 {["Ondemand"].indexOf(
        this.props.orderTypeActive
      ) > -1 && (
          <hr className={styles.hr} />
        )}
        <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
          <IconProvider Icon={DROPOFF} size='16' />
        <Typography text={t("Deliver to")} weight='Body_Middle_Bold' />
              {this.props.address.length == 0 && <span className={styles.starRequired}>*</span>}
  {this.props.ActivescheduleSetting &&
        <Schedule orderType={this.props.orderTypeActive}
          scheduleDateBefore={this.props.scheduleDateBefore}
          scheduleDateAfter={this.props.scheduleDateAfter} 
            activeVehicleType={this.props.deliveryMethodData}
          activePickupDropOff={{type:"picdeliverykup"}}
        />} 
        </div>

        <div className={styles.PickupOnlyNewOrderContainerSecondRow}>
          <SearchList DefaultListPreview={(isEmpty(this.props.address) && this.state.servicepoints && this.state.servicepoints.length > 0 && this.props.locationType != "address") && <div className={styles.DefaultListPreview}>
            <Typography weight='Body_Tiny_Medium' text={this.props.t("All Service points")} style={{ marginTop: "16px", marginBottom: "4px", width: "100%", width: "calc(100% - 24px)", marginInlineStart: "12px", marginInlineEnd: "12px", marginTop: "8px", color: "#484848" }} />
            <div className={styles.DefaultListItemsContainerPreview}>
              {this.state.servicepoints.map((item) => {
                return <ServicePoint_addressItem data={item} onclick={() => { this.GetserachListItemOnclickSP(item) }} />
              })}
            </div>

          </div>}  errorActionOnClick={()=>{
          window.location.replace("/admin/service-points/create")
        }} 
            inputIcon={<img src={this.props.locationType == "address" ? location_gray : service_point} />}

            onChange={this.props.locationType == "address" ? (e) => this.handleDropOffInputs(e, "address") : (e) => this.handleSearchSPInput(e, "address")} style={{ zIndex: "2" }} value={this.props.address}
            placeHolder={this.props.locationType == "address" ? t("Search and select address") : t("Search and select service point")}
            isloading={this.props.locationType == "address" ? this.props.suggestListPickUpDropOffLoading : this.state.servicepointsIsLoading}
            listItemOnclick={this.props.locationType == "address" ? this.GetserachListItemOnclick() : this.GetserachListItemOnclickSP}
            error={this.GetSearchListError()} errorDescription={this.GetSearchListError()?.errorDescription} errorTitle={this.GetSearchListError()?.errorTitle} errorIcon={this.GetSearchListError()?.errorIcon}
            ListItemChildren={this.props.locationType == "address" ? this.GetserachListItem() : ServicePoint_addressItemEditAddress}
            list={this.serachListData()} inputInnerChildren={(this.state.isLocalAddressActive && this.props.locationType == "address") ? (<DropDown size='Small' placement='bottomEnd' text={this.state.localSearchIsActive ? t("Local") : t("Map")} data={[t("Map"), t("Local")]} onClick={this.handleChangeLocalSearch} />) : null}
          />
          {this.props.locationType == "address" && <Button icon={LOCATION} size='Medium' type='Secondary' style={{ marginInlineEnd: "7px" }} onClick={this.handleCollapse} isActive={this.props.activePickupDropOff.id === this.state.id} />}
          {this.props.locationType == "address" && <Button icon={ADDRESS_BOOK} size='Medium' type='Secondary' disabled={(String(this.props.customerId).length > 0) ? false : true} onClick={this.openAddressbook} isActive={this.props.addressBookSource} />}
          {(this.props.dropOffsCount > 1 && !this.props.first) && <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={this.removeDropOff} />}

        </div>
      </div>
    } else {

      return (< >

        {/* <div className={styles.PickupOnlyNewOrderSelectedContainerFrow} style={{ marginInlineStart: (this.props.namex && this.props.namex.length > 0) && "10px", alignSelf: "center" }}>
          {(this.props.namex && this.props.namex.length > 0) && <img src={service_point} />}

          <div style={{ display: "flex", flexDirection: "column", gap: "0px", flex: "1" }}>
            {(this.props.namex && this.props.namex.length > 0) && <Typography text={this.props.namex} weight='Body_Middle_Medium' style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px"
            }} />}
            <Typography text={this.props.address} weight='Body_Tiny_Regular' style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px"
            }} />
          </div>

        </div>
        <Button icon={INFO_CIRCLE} size='Medium' type='Secondary' badge={!this.pickupRequiredCheck() && true} onClick={this.handleShowInfo} isActive={this.props.activePickupDropOff.id === this.state.id} style={{ marginInlineEnd: "12px" }} />
        <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={this.resetPickup} />
        {this.props.activePickupDropOff.id === this.state.id && <DropoffInfoEditOrder handleShowInfo={this.handleShowInfo} {...this.props} />}
     */}

         <div className={clsx(styles.PickupOnlyNewOrderSelectedContainer, ["Ondemand" , "PickupDelivery"].indexOf(
          this.props.orderTypeActive
        ) > -1 && styles.PickupDelivery)}>
        {["Ondemand"].indexOf(
          this.props.orderTypeActive
        ) > -1 && (
            <hr className={styles.hr2} />
          )}


      <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
      {this.props.dropOffsCount > 1 && <IconProvider Icon={DRAG} size='16' style={{ cursor: "pointer", marginInlineEnd: "8px" }} />}

{(this.props.orderTypeActive == "Ondemand" && this.props.dropOffsCount > 1) ? <span className={styles.dropNumber} style={{ marginInlineEnd: "2px" }}>{this.props.index + 1}</span> : <IconProvider Icon={DROPOFF} size='16' />}        <Typography text={t("Deliver to")} weight='Body_Middle_Bold' />
        {this.props.address.length == 0 && <span className={styles.starRequired}>*</span>}
        {this.props.ActivescheduleSetting &&
        <Schedule orderType={this.props.orderTypeActive}
          scheduleDateBefore={this.props.scheduleDateBefore}
          scheduleDateAfter={this.props.scheduleDateAfter} 
            activeVehicleType={this.props.deliveryMethodData}
          activePickupDropOff={{type:"delivery"}}
          
          firstDropOff={this.props.first}
          id={this.props.id}
        />} 
      </div>

         <div className={styles.PickupOnlyNewOrderSelectedContainerFrow} style={{marginTop:(this.props.name && this.props.name.length > 0) && "4px"}}>
          {(this.props.name && this.props.name.length > 0) && <img src={service_point} />}
          <div style={{ display: "flex", flexDirection: "column", gap: "0px", flex: "1" }}>
            {(this.props.name && this.props.name.length > 0) && <Typography text={this.props.name} weight='Body_Middle_Regular' style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px"
            }} />}
            <Typography text={this.props.address} weight={(this.props.name && this.props.name.length > 0) ? "Body_Tiny_Regular" : 'Body_Middle_Regular'} style={{
            width: "293px", overflow: 'hidden',
            textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px" , color : (this.props.name && this.props.name.length > 0) ? "rgba(128, 128, 128, 1)" : 'rgba(72, 72, 72, 1)'
          }} />
          </div>

          <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={() => (!this.props.first) ? this.removeDropOff(this.props.id) : this.resetPickup()} />

        </div>  


       
     <DropoffInfoEditOrder handleShowInfo={this.handleShowInfo} {...this.props} pickupRequiredCheck={this.pickupRequiredCheck()} />

      </div>

    
      </ >)
    }




  }
}

const mapStateToProps = (state ,ownProps) => ({
  favAddresss: state.FavAddress.list,
  customerid: state.FavAddress.customerId,
  mapRef: state.Map.mapRef,
  center: state.Map.center,

  activePickupDropOff: state.EditOrder.editOrder.activePickupDropOff,
  list: state.EditOrder.editOrder.dropOffs.list,
  loading: state.EditOrder.editOrder.dropOffs.loading,
  center: state.Map.center,
  suggestListPickUpDropOffLoading:
    state.EditOrder.editOrder.suggestListPickUpDropOffLoading,
  suggestListPickUpDropOffOrdered:
    state.EditOrder.editOrder.suggestListPickUpDropOffOrdered,
  suggestPickUpDropOffListData:
    state.EditOrder.editOrder.suggestPickUpDropOffListData,
    openAddressBook: state.Addressbook.openAddressBookInNewOrder,
    addressBookSource: state.Addressbook.openAddressBookInNewOrder
    ? state.Addressbook.sourceOfAddressBookInNewOrder
      ? state.Addressbook.sourceOfAddressBookInNewOrder.type == "dropoff" &&
      ownProps.id == state.Addressbook.sourceOfAddressBookInNewOrder.id
      : false
    : false,
  isScheduled: state.ViewTravel.pureData ? state.ViewTravel.pureData.isScheduled : false,
  activeVehicleType: state.EditOrder.editOrder.service ? (state.EditOrder.editOrder.service.activeVehicleType ? state.EditOrder.editOrder.service.activeVehicleType : null) : null,
  currentService: state.EditOrder.editOrder.service ? (state.EditOrder.editOrder.service.activeVehicleType ? state.EditOrder.editOrder.service.activeVehicleType.id : null) : null,
  ActivescheduleSetting: state.ViewTravel.pureData?.deliveryMethod?.scheduleSetting?.isActive,
  recentAddress: state.EditOrder.editOrder.customer.recentAddreess ,
  orderType: state.ViewTravel.pureData
  ? state.ViewTravel.pureData.type
    ? state.ViewTravel.pureData.type
    : null
  : null,
  deliveryMethod: state.ViewTravel.pureData.deliveryMethod?.id ,
  deliveryMethodSetting: state.ViewTravel.pureData.deliveryMethod?.setting  ,
  deliveryMethodData : state.ViewTravel.pureData.deliveryMethod ,
  orderTypeActive : state.ViewTravel.pureData.type ,

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));



function ServiceCustomHook(props) {
  const service = useLocalServices(props.serviceId);

  return (
    <>
      {(service && service.scheduleSetting.isActive) &&
        props.children
      }
    </>
  );
}